import { captureException, captureMessage } from '@sentry/react'

const isDevelopment = process.env.NODE_ENV === 'development'

class Logger {
  info = (message, ...args) => {
    console.log(message, ...args)

    if (!isDevelopment) {
      captureMessage(message)
    }
  }

  error = (error, showReportDialog = false, ...args) => {
    if (isDevelopment) {
      console.error(error, ...args)
    }

    if (!isDevelopment) {
      captureException(error, {
        extra: {
          showReportDialog,
        },
      })
    }
  }
}

const logger = new Logger()

export default logger
